var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7977_1839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23H5.5C4.675 23 4 22.325 4 21.5V2.5C4 1.675 4.675 1 5.5 1H14.5L20 6.5V21.5C20 22.325 19.325 23 18.5 23Z",
    fill: "#3086F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1L20 6.5H14.5V1Z",
    fill: "#0C67D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.75H7.5V9.5H16.5V10.75ZM16.5 12.5H7.5V13.75H16.5V12.5ZM14 15.5H7.5V16.75H14V15.5Z",
    fill: "#FDFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7977_1839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    fill: "white",
    transform: "translate(4 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docsIcon.98cb26f22aa7c49215fb2d569dfb488e.svg";
export { ForwardRef as ReactComponent };